export const shouldForwardProp = (name: string): boolean => {
  const propsToNotForward = ['bgColor', 'textColor'];
  return !propsToNotForward.includes(name);
};
